import { SparqlEndpoint } from "@plazi/synolib";
import Awesomplete from "awesomplete";
import Taxomplete from "taxomplete";

import { getEndpoint } from "../endpoints.ts";

/** Shown in the empty search field, and searched for when it stays empty. */
const EXAMPLE_NAME = "Sadayoshia acamar";

export class SynoForm extends HTMLElement {
  connectedCallback() {
    if (this.innerHTML) return;

    const params = new URLSearchParams(document.location.search);
    const SHOW_COL = params.has("show_col");
    const START_WITH_SUBTAXA = params.has("subtaxa");
    const NOSYNONYMS = params.has("nosynonyms");
    const NAME = params.get("q");
    const ENDPOINT_URL = getEndpoint();

    const nameInput = document.createElement("input");
    nameInput.type = "text";
    nameInput.placeholder = EXAMPLE_NAME;
    if (NAME) nameInput.value = NAME;

    const colCheckLabel = document.createElement("label");
    colCheckLabel.innerText = "Show CoL-synonyms.";
    const colCheck = document.createElement("input");
    colCheck.type = "checkbox";
    colCheck.checked = NAME ? SHOW_COL : true;
    colCheckLabel.prepend(colCheck);

    const subtaxaCheckLabel = document.createElement("label");
    subtaxaCheckLabel.innerText = "Include subtaxa of search term.";
    const subtaxaCheck = document.createElement("input");
    subtaxaCheck.type = "checkbox";
    subtaxaCheck.checked = NAME ? START_WITH_SUBTAXA : false;
    subtaxaCheckLabel.prepend(subtaxaCheck);

    const nosynonymsCheckLabel = document.createElement("label");
    nosynonymsCheckLabel.innerText = "Do not search for Synonyms";
    const nosynonymsCheck = document.createElement("input");
    nosynonymsCheck.type = "checkbox";
    nosynonymsCheck.checked = NAME ? NOSYNONYMS : false;
    nosynonymsCheckLabel.prepend(nosynonymsCheck);

    colCheck.disabled = nosynonymsCheck.checked;
    nosynonymsCheck.addEventListener(
      "change",
      () => colCheck.disabled = nosynonymsCheck.checked,
    );

    const button = document.createElement("button");
    button.innerText = "Go";

    const search = document.createElement("div");
    search.className = "search";
    search.append(nameInput, button);

    const label = document.createElement("span");
    label.innerText = "(Options applied on next search)";
    // label.style.gridColumn = "auto / span 2";

    const options = document.createElement("div");
    options.className = "options";
    options.append(
      "Options: ",
      colCheckLabel,
      subtaxaCheckLabel,
      nosynonymsCheckLabel,
      label,
    );

    this.append(search, options);

    const go = () => {
      const params = new URLSearchParams({
        q: nameInput.value.trim() || EXAMPLE_NAME,
      });
      if (colCheck.checked) params.append("show_col", "");
      if (subtaxaCheck.checked) params.append("subtaxa", "");
      if (nosynonymsCheck.checked) params.append("nosynonyms", "");
      // if (sorttreatmentsCheck.checked) {
      //   params.append("sort_treatments_by_type", "");
      // }
      // a server named in the link stays in effect
      const server = new URLSearchParams(document.location.search).get(
        "server",
      );
      if (server) params.append("server", server);
      document.location.hash = "";
      document.location.search = params.toString();
    };

    button.addEventListener("click", go);
    nameInput.addEventListener("keyup", (e) => {
      if (e.key === "Enter") go();
    });

    // we can only create the Taxomplete when nameInput has a parent
    const taxomplete = new Taxomplete(nameInput, ENDPOINT_URL);
    taxomplete.action = go;
    // an endpoint chosen in the settings menu applies to the suggestions too;
    // Taxomplete keeps its endpoint in this field and reads it for each query
    document.addEventListener("endpoint-change", (e) => {
      taxomplete._sparqlEndpoint = new SparqlEndpoint(
        (e as CustomEvent<string>).detail,
      );
    });
    // Taxomplete renders the suggestions, which come from the endpoint, as
    // HTML; render them as text instead.
    const awesomplete = Awesomplete.all.find((a: { input: HTMLElement }) =>
      a.input === nameInput
    );
    if (awesomplete) awesomplete.item = suggestionItem;
  }
}

/** Like Taxomplete's suggestion item, but without parsing it as HTML. */
function suggestionItem(suggestion: string, input: string): HTMLLIElement {
  const text = String(suggestion);
  const spacePos = text.slice(0, -1).indexOf(" ");
  // the input matches either the start or the second word of the suggestion
  const start = spacePos !== -1 && !input.includes(" ") ? spacePos + 1 : 0;
  const end = start + input.length;
  const mark = document.createElement("mark");
  mark.textContent = text.slice(start, end);
  const li = document.createElement("li");
  li.setAttribute("aria-selected", "false");
  li.append(text.slice(0, start), mark, text.slice(end));
  return li;
}

customElements.define("syno-form", SynoForm);
